import { css, styled } from 'styled-components';

import PropTypes from 'prop-types';

import { withText } from '../../text/textStore';

import TitleSection from '../TitleSection';
import HeadingLevelOne from '../HeadingLevelOne';
import SimpleHeader from '../SimpleHeader/SimpleHeader';
import { Box } from '@cof/plastic-components';

// on <= iOS 15 overflow-x: clip; is not supported. Duplicate property used as fallback
const HeroWrapper = styled('div')`
    ${({ theme }: any) => css`
        overflow-y: visible;
        /* stylelint-disable declaration-block-no-duplicate-properties */
        overflow-x: hidden;
        overflow-x: clip;
        background-color: ${theme.colors.capitalOne.blue750};
        ${theme.components.HeroWrapper}
    `}
`;
HeroWrapper.displayName = 'HeroWrapper';

export const FormTitleSection = styled(TitleSection)`
    ${({ theme }: any) => css`
        padding-top: ${theme.space.sm};
        padding-bottom: ${theme.space.md};
        margin: auto;
        max-width: 92rem;
        ${theme.components.FormTitleSection}
    `}
`;
FormTitleSection.displayName = 'FormTitleSection';

export const StandardTitleText = styled.span`
    ${({ theme }: any) => css`
        color: ${theme.colors.global.white};
        ${theme.components.StandardTitleText}
    `}
`;
StandardTitleText.displayName = 'StandardTitleText';

export const HeaderText = styled.span`
    ${({ theme }: any) => css`
        color: ${theme.colors.global.white};
        font-size: ${theme.fontSizes.textMediumDesktop};
        ${theme.breakpoints.mq.tabletMin} {
            font-size: ${theme.fontSizes.textLargeDesktop};
        }
        ${theme.components.HeaderText}
    `}
`;
HeaderText.displayName = 'HeaderText';

export const HeaderSection = styled(Box)`
    ${({ theme }: any) => css`
        padding-bottom: ${theme.space.sm};
        margin: auto;
        max-width: 39rem;
        text-align: center;
        ${theme.breakpoints.mq.tabletMin} {
            max-width: 75rem;
            padding-bottom: ${theme.space.md};
        }
        ${theme.components.HeaderSection}
    `}
`;
HeaderSection.displayName = 'HeaderSection';

export const StyledPageTitle = styled(HeadingLevelOne)`
    font-size: 6rem;
    ${({ theme }: any) => css`
        ${theme.breakpoints.mq.tabletMax} {
            font-size: 5rem;
        }
        ${theme.breakpoints.mq.mobileMax} {
            font-size: 3.2rem;
        }
    `}
`;
StyledPageTitle.displayName = 'StyledPageTitle';

export const EmphasizedTitleText = styled.span`
    ${({ theme }: any) => css`
        color: ${theme.colors.capitalOne.teal450};
        ${theme.components.EmphasizedTitleText}
    `}
`;
EmphasizedTitleText.displayName = 'EmphasizedTitleText';

export const SimpleHeaderTitleSection = styled(TitleSection)`
    ${({ theme }: any) => css`
        text-align: left;
        max-width: 67.4rem;
        padding: 0 ${theme.space.sm} 0 ${theme.space.sm};
        margin: auto;
        box-sizing: content-box;
        background-color: unset;
    `}
`;
SimpleHeaderTitleSection.displayName = 'FormTitleSection';

// @ts-expect-error TS7031: Binding element 'text' implicitly has an 'any' type.
const QuotationHeroSection = ({ Text: text, isPartnerAggsEdit = false }) => {
    return (
        <HeroWrapper data-qm-allow>
            {isPartnerAggsEdit ? (
                <>
                    <FormTitleSection>
                        <HeadingLevelOne px={['sm', 'xl', 'md']}>
                            <StandardTitleText data-qa-id="page-title-2" data-qm-allow>
                                {text({ path: 'EditTitle' })}
                            </StandardTitleText>
                        </HeadingLevelOne>
                    </FormTitleSection>
                    {/* TODO: Clean up - use constants in the styled component */}
                    {/* @ts-expect-error TS2769: No overload matches this call. */}
                    <HeaderSection pb={['3.2rem!important', '4.8rem!important']}>
                        <HeaderText data-qa-id="page-header">{text({ path: 'EditHeader' })}</HeaderText>
                    </HeaderSection>
                </>
            ) : (
                <SimpleHeaderTitleSection>
                    <SimpleHeader />
                </SimpleHeaderTitleSection>
            )}
        </HeroWrapper>
    );
};
QuotationHeroSection.propTypes = {
    Text: PropTypes.func.isRequired,
    isPartnerAggsEdit: PropTypes.bool
};

const WrappedQuotationHeroSection = withText('QuotationForm')(QuotationHeroSection);

WrappedQuotationHeroSection.displayName = 'QuotationHeroSection';

export default WrappedQuotationHeroSection;
